import { NotFoundClusterItem } from './types';

import { makeSearchBoxCriteria } from '@cast/shared-search-ui';

export const notFoundClustersSearchCriteria =
  makeSearchBoxCriteria<NotFoundClusterItem>(
    {
      key: 'Cluster name:',
      prop: 'name',
    },
    {
      key: 'Project ID:',
      prop: 'providerNamespaceId',
    }
  );
